import { render } from "./MessageInbox.vue?vue&type=template&id=308dddac"
import script from "./MessageInbox.vue?vue&type=script&lang=js"
export * from "./MessageInbox.vue?vue&type=script&lang=js"

import "./MessageInbox.vue?vue&type=style&index=0&id=308dddac&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__